<template>
  <div
    :class="[
      vertical || input ? 'tw-border-l' : 'tw-border-t',
      input
        ? 'tw-w-0 tw-h-[calc(100%-1rem)] tw-my-2 tw-border-white tw-opacity-30'
        : 'tw-w-full',
      isFrontend && !input
        ? alt
          ? 'tw-border-dark-2'
          : 'tw-border-dark-1'
        : '',
    ]"
  />
</template>
<script>
import { isFrontend } from '@config'
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    input: {
      type: Boolean,
      default: false,
    },
    alt: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      isFrontend,
    }
  },
}
</script>
